// WhatsApp / contact configuration for the landing page
// Update these phone numbers (include country code + DDD, no symbols)
// Example: 5519999999999 (55=Brazil, 19=DDD, 99999-9999)

export const WHATSAPP = {
  mogi_guacu: "5519999999999",
  artur_nogueira: "5519999999999",
  online: "5519999999999",
};

export const INSTAGRAM_HANDLE = "@dramarianaalves";
export const INSTAGRAM_URL = "https://instagram.com/dramarianaalves";

export const buildWhatsappLink = (phone, message) => {
  const encoded = encodeURIComponent(
    message ||
      "Olá Dra. Mariana! Gostaria de agendar uma consulta. Pode me ajudar?"
  );
  return `https://wa.me/${phone}?text=${encoded}`;
};
